import { ConfigurationContext } from '@news-mono/web-common'
import { EventPostsListingV4ResponseWithoutDeletedDTO } from '@west-australian-newspapers/publication-types'
import { useContext, useState } from 'react'
import { liveEventDebug } from '.'

export const useFetchEventPosts = () => {
    const config = useContext(ConfigurationContext)
    const [isFetching, setIsFetching] = useState(false)

    const fetchEventPosts = async (params: {
        publicationId: string
        reference?: string
        after?: number
        before?: number
    }) => {
        setIsFetching(true)

        const queryParams = new URLSearchParams({
            before: `${params.before ?? ''}`,
            after: `${params.after ?? ''}`,
            reference: params.reference ?? '',
        }).toString()

        liveEventDebug('Fetching posts: %o', { queryParams })

        const url = `${config.contentApi}/v4/publication/${params.publicationId}/entries?${queryParams}`

        const response = await fetch(url, {})

        if (!response.ok) {
            setIsFetching(false)

            liveEventDebug('Error fetching posts: %o', { response })
            throw new Error('Unable to fetch posts')
        }

        const data: EventPostsListingV4ResponseWithoutDeletedDTO =
            await response.json()

        setTimeout(() => setIsFetching(false), 2000)

        liveEventDebug('Success fetching posts: %o', data)

        return data
    }

    return { fetchEventPosts, isFetching }
}
